import _swal from "sweetalert2";

/**
 * UYAP oturumu başka bir hesaba ait: engelleyici uyarı (DEV-3899).
 *
 * uyap-plugin kimlik kapısı (UyapRequest.kimlikKapisi) uyuşmazlıkta HER engellenen
 * istekte kancayı çağırır; arka planda tekrarlayan istekler aynı diyaloğu üst üste
 * açmasın diye tek diyalog + kapanıştan sonra kısa bekleme uygulanır. Eskiden bu uyarı
 * eski oturum yoklamasında satır içi yazılıydı; metin aynen korunuyor.
 *
 * Player'a/socket'e dokunmaz: botu durdurmak imzacı tarafının işi. Kapı bağlantı
 * bayrağını zaten düşürüyor.
 */
export const KIMLIK_UYUSMAZLIGI_BASLIK = "UYAP oturumu bu hesaba ait değil";
export const KIMLIK_UYUSMAZLIGI_METNI =
    "Hesabınızda kayıtlı TC kimlik numarası ile açık olan UYAP oturumunun TC kimlik numarası " +
    "farklı olduğu için işlem yapılamaz. Kendi hesabınızla giriş yapıp kendi e-imzanızı kullanın.";

export function kimlikUyusmazligiUyarisiOlustur(
    goster?: (secenek: any) => any,
    simdi?: () => number,
    beklemeMs?: number
): (sebep?: any) => void {
    const diyalog = goster || ((secenek: any) => _swal.fire(secenek));
    const saat = simdi || (() => Date.now());
    const bekleme = beklemeMs === undefined ? 10000 : beklemeMs;
    let acik = false;
    let kapanis = 0;

    return () => {
        if (acik) return;
        if (kapanis > 0 && saat() - kapanis < bekleme) return;
        acik = true;
        let sonuc: any;
        try {
            sonuc = diyalog({
                title: KIMLIK_UYUSMAZLIGI_BASLIK,
                text: KIMLIK_UYUSMAZLIGI_METNI,
                icon: "error",
                allowOutsideClick: false,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Tamam"
            });
        } catch (e) {
            acik = false;
            return;
        }
        Promise.resolve(sonuc).then(() => {
            acik = false;
            kapanis = saat();
        }, () => {
            // Diyalog hiç gösterilemedi: sonraki engellenen istek yeniden denesin.
            acik = false;
        });
    };
}
